import * as constActions from './const';
import initialState from './initialState';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_MASTER_SLAVE_SUCCESS:
      return Object.assign({}, state, {
        masterSlave: action.masterSlave
      });
    case constActions.SET_IS_GLOBAL_MODE:
      return Object.assign({}, state, {
        isGlobalMode: action.result
      });
    case constActions.SET_CLIENT_TOKEN:
      return Object.assign({}, state, {
        clientToken: action.clientToken
      });
    case constActions.RESET_STORE:
      // From here we can take action only at this "masterSlave" state
      // But, as we have taken care of this particular "RESET_STORE" action
      // in rootReducer, we can use it to CLEAR the complete Redux Store's state
      return initialState;

    default:
      return state;
  }
}
